


























































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { DownloadIcon, EditIcon } from "vue-feather-icons";
import Loader from "../../ui/Loader.vue";

@Component({
  components: {
    DownloadIcon,
    EditIcon,
    Loader,
  },
})
export default class AssetLeaseHistory extends Vue {
  @Prop() id!: string;
  assetsList: any = [];
  isLoading = false;

  mounted() {
    this.fetchLeaseListByAsset();
  }
  async fetchLeaseListByAsset() {
    try {
      this.isLoading = true;
      const response = await fetch(
        `${this.$store.state.PROTOCOL}://api.assettracker.${this.$store.state.ROOT_URL}/lease/asset/${this.id}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (response.status === 200) {
        this.assetsList = await response.json();
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.isLoading = false;
    }
  }
}
